/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Zoom_OutInputs */

const en_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out`)
};

const ar_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصغير`)
};

const bn_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জুম আউট`)
};

const de_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkleinern`)
};

const es_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alejar`)
};

const fr_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom arrière`)
};

const pt_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afastar`)
};

const zh_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩小`)
};

const tr_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzaklaştır`)
};

const ru_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уменьшить`)
};

const pl_image_inspector_zoom_out = /** @type {(inputs: Image_Inspector_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oddal`)
};

/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Image_Inspector_Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_zoom_out = /** @type {((inputs?: Image_Inspector_Zoom_OutInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Zoom_OutInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_zoom_out(inputs)
	if (locale === "bn") return bn_image_inspector_zoom_out(inputs)
	if (locale === "de") return de_image_inspector_zoom_out(inputs)
	if (locale === "es") return es_image_inspector_zoom_out(inputs)
	if (locale === "fr") return fr_image_inspector_zoom_out(inputs)
	if (locale === "pt") return pt_image_inspector_zoom_out(inputs)
	if (locale === "zh") return zh_image_inspector_zoom_out(inputs)
	if (locale === "tr") return tr_image_inspector_zoom_out(inputs)
	if (locale === "ru") return ru_image_inspector_zoom_out(inputs)
	if (locale === "pl") return pl_image_inspector_zoom_out(inputs)
	return en_image_inspector_zoom_out(inputs)
});